import React, { useContext } from "react";
import { createBrowserRouter, RouterProvider } from "react-router-dom";
import HomePage from "./pages/HomePage";
import NotFoundPage from "./pages/NotFoundPage";
import { SCFooter } from "./components/Footer";
import { AppContext } from "./context/AppContext";
import { Spinner } from "react-bootstrap";
import DetailPage from "./pages/DetailPage";
import { SCHeader } from "./components/Header";
import GenericPage from "./pages/GenericPage";
import EventsPage from "./pages/EventsPage";

const router = createBrowserRouter([
  {
    path: `/:scientificCommittee`,
    element: <HomePage />,
  },
  {
    path: `/:scientificCommittee/:type/:id`,
    element: <DetailPage />,
  },
  {
    path: `/:scientificCommittee/:pageId`,
    element: <GenericPage />,
  },
  {
    path: `/:scientificCommittee/past-events`,
    element: <EventsPage />,
  },
  {
    path: "*",
    element: <NotFoundPage />,
  }
],
  {
    basename: process.env.REACT_APP_BASE_PATH,
  }
);

const AppRouter = () => {
  const { state } = useContext(AppContext) ?? {};
  const fetching = state?.fetching;
  const error = state?.error;

  if (fetching) {
    return (
      <div className="d-flex justify-content-center align-items-center min-vh-100">
        <Spinner animation="border" role="status" variant="primary">
          <span className="visually-hidden">Loading...</span>
        </Spinner>
      </div>
    );
  }

  if(error) {
    return (
      <>
        <SCHeader />
        <NotFoundPage />
        <SCFooter />
      </>
  );
  }

  return (
    <>
      <SCHeader/>
      <RouterProvider router={router} />
      <SCFooter />
    </>
  );
};

export default AppRouter;
